<div class="container-fluid">
    <div class="row">
        <div class="col-12" *ngIf="ShowPowerBi">
            <powerbi-report [embedConfig]="reportConfig" [cssClassName]="'report-container'"></powerbi-report>
        </div>
    </div>
</div>